import React, { useMemo } from 'react'
import { useRouteMatch, useLocation, useHistory } from 'react-router-dom'
import Button from '@material-ui/core/Button'
import { PageHeader } from 'components/page-header'
import { Tabs, Tab } from 'components/tabs'
import InlineCountBadge from 'components/inline-count-badge'
import LeadsQuery from './leads-query'
import { useGetLeads } from './api-hooks'
import { isUnviewedNewLead } from './utils'
import { ReactComponent as AutoRespondersIcon } from 'images/icons/auto-responders.svg'

const LeadsPage = React.memo(() => {
  const { path } = useRouteMatch()
  const location = useLocation()
  const history = useHistory()

  const {
    loading: leadsLoading,
    error: leadsError,
    data: leadsData,
    previousData,
    refetch: leadsRefetch,
  } = useGetLeads()

  const resolvedLeadsData = leadsData ?? previousData

  const unviewedLeadsCount = useMemo(() => {
    const inquiries = resolvedLeadsData?.coachingInquiries ?? []
    return inquiries.filter(isUnviewedNewLead).length
  }, [resolvedLeadsData])

  const coachingInquiries = resolvedLeadsData?.coachingInquiries ?? []

  const queryParams = new URLSearchParams(location.search)
  const tabValue = queryParams.get('tab') === 'contacted' ? 'contacted' : 'new'

  const handleTabChange = (_, newValue) => {
    if (newValue === tabValue) {
      return
    }
    history.push(`${path}?tab=${newValue}`)
  }

  const newTabLabel = useMemo(
    () => <InlineCountBadge count={unviewedLeadsCount}>New</InlineCountBadge>,
    [unviewedLeadsCount],
  )

  const tabs = (
    <Tabs value={tabValue} onChange={handleTabChange}>
      <Tab label={newTabLabel} value="new" />
      <Tab label="Contacted" value="contacted" />
    </Tabs>
  )

  const actions = (
    <Button
      variant="outlined"
      color="primary"
      startIcon={<AutoRespondersIcon style={{ width: 20, height: 20 }} />}
      onClick={() => history.push('/pga-coach/settings/leads-auto-reply')}
    >
      Lead Auto-Reply
    </Button>
  )

  return (
    <>
      <PageHeader
        title="Leads"
        tabs={tabs}
        actions={actions}
        fixedMobileActions
      />
      <LeadsQuery
        {...{
          data: coachingInquiries,
          coachingLeadContactMethodOptions:
            resolvedLeadsData?.coachingLeadContactMethodOptions ?? [],
          freeTierLimitsReached:
            resolvedLeadsData?.currentUser?.attributes?.freeTierLimitsReached ??
            [],
          error:
            leadsError && coachingInquiries.length === 0
              ? leadsError
              : undefined,
          loading: leadsLoading && !resolvedLeadsData,
          refetch: leadsRefetch,
          tab: tabValue,
        }}
      />
    </>
  )
})

export default LeadsPage
